import React, { useState, useCallback } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "../components/AdminSidebar";
import { Col, Row } from "react-bootstrap";

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = useCallback(() => setSidebarOpen((prev) => !prev), []);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);

  return (
    <Row className="gx-0 bg-gradient-black">
      {sidebarOpen && (
        <div className="sidebar-backdrop" onClick={closeSidebar} />
      )}
      <Col xl={2} className={sidebarOpen ? "" : "d-none d-xl-block"}>
        <AdminSidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      </Col>
      <Col xl={10} className="main-content">
        <Outlet context={{ toggleSidebar }} />
      </Col>
    </Row>
  );
};

export default AdminLayout;
